import { isNull } from "lodash";

export interface Address {
  address?: string | null;
  city?: string | null;
  country?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export function addressMerge({
  originalAddress,
  updatedAddress
}: {
  originalAddress: Address | undefined;
  updatedAddress: Address;
}): Address {
  return <Address>{
    address: isNull(updatedAddress.address)
      ? null
      : updatedAddress.address || originalAddress?.address || "",
    city: isNull(updatedAddress.city)
      ? null
      : updatedAddress.city || originalAddress?.city || "",
    country: isNull(updatedAddress.country)
      ? null
      : updatedAddress.country || originalAddress?.country || "",
    state: isNull(updatedAddress.state)
      ? null
      : updatedAddress.state || originalAddress?.state || "",
    zipCode: isNull(updatedAddress.zipCode)
      ? null
      : updatedAddress.zipCode || originalAddress?.zipCode || ""
  };
}
